import { Badge, Flex, Space } from '@billy/design-system'
import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

import { vatDeclarationStatusToColorVariant } from '../../../../../../consts/vatDeclarationStatusToColorVariant'
import { vatDeclarationStatusToTitleKey } from '../../../../../../consts/vatDeclarationStatusToTitleKey'
import { VatDeclarationStatus } from '../../../../../../enums/vatDeclarationStatus'

interface VatDeclarationsPeriodSidebarStateProps {
  status: VatDeclarationStatus
}

export const VatDeclarationsPeriodSidebarState = ({
  status,
}: VatDeclarationsPeriodSidebarStateProps): ReactElement | null => {
  const { t } = useTranslation()
  const translationKey = vatDeclarationStatusToTitleKey[status]
  const variant = vatDeclarationStatusToColorVariant[status]

  if (!status) {
    return null
  }

  return (
    <Flex justifyContent="center">
      <Badge color={variant} mode="subtle">
        {t(translationKey)}
      </Badge>
      <Space size="s12" />
    </Flex>
  )
}
